"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import { Suspense, useEffect } from "react";

function PostHogPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const posthog = usePostHog();

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }

      posthog.capture("$pageview", { $current_url: url });

      // after capturing pageview, remove search params (but keep april param for testing)
      const params = new URLSearchParams(searchParams.toString());
      const aprilParam = params.get('april');
      
      if (aprilParam === 'true') {
        router.replace(`${pathname}?april=true`);
      } else {
        router.replace(pathname);
      }
    }
  }, [pathname, searchParams, posthog, router]);

  return null;
}

export default function SuspendedPostHogPageView() {
  return (
    <Suspense fallback={null}>
      <PostHogPageView />
    </Suspense>
  );
}
